import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=1c21a304&scoped=true&"
import script from "./Applicant.vue?vue&type=script&lang=js&"
export * from "./Applicant.vue?vue&type=script&lang=js&"
import style0 from "./Applicant.vue?vue&type=style&index=0&id=1c21a304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21a304",
  null
  
)

export default component.exports